//
// formvalidation.js
//

function fvDisabledIsValid(fv, parent = '.form-group') {
    fv.on('core.element.validated', e => {

        // e.element presents the field element
        // e.valid indicates the field is valid or not
        if (e.valid) {
            // Remove has-success from the container
            const groupEle = FormValidation.utils.closest(e.element, parent);
            if (groupEle) {
                FormValidation.utils.classSet(groupEle, {
                    'has-success': false,
                });
            }

            // Remove is-valid from the element
            FormValidation.utils.classSet(e.element, {
                'is-valid': false,
            });
        }
    });
}

// Make available globally
window.fvDisabledIsValid = fvDisabledIsValid;